import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

// TODO: Get this icon to fill with currentColor - not default to white

const BottombarInvertedIcon = (props: SvgIconProps) => (
    <SvgIcon viewBox="0 0 18 18" {...props}>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g transform="translate(-870 -129) translate(858 51) translate(0 72)">
                        <g>
                            <path
                                d="M0 0L18 0 18 18 0 18z"
                                transform="translate(12 6)"
                            />
                            <path
                                fill="#FFFFFF"
                                d="M15.25 2.25c1.105 0 2 .895 2 2v9.5c0 1.105-.895 2-2 2H2.75c-1.105 0-2-.895-2-2v-9.5c0-1.105.895-2 2-2h12.5zm.5 1.5H2.25v10.5h13.5V3.75zm-1.5 7.5v1.5H3.75v-1.5h10.5z"
                                transform="translate(12 6)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);

export default BottombarInvertedIcon;
